import { render, staticRenderFns } from "./table3.vue?vue&type=template&id=30bba550&scoped=true"
import script from "./table3.vue?vue&type=script&lang=js"
export * from "./table3.vue?vue&type=script&lang=js"
import style0 from "./table3.vue?vue&type=style&index=0&id=30bba550&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bba550",
  null
  
)

export default component.exports